import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Helmet } from 'react-helmet';
import { sendEvent } from 'cityads-v3/utils/htmlUtils';
import { connect } from 'react-redux';

import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import classes from './Article.scss';

@connect(
  state => ({
    isMobile: state.app.isMobile,
  })
)
export default class Article extends Component {
  static propTypes = {
    title          : PropTypes.string,
    inPopup        : PropTypes.bool,
    pageTitle      : PropTypes.string,
    pageDescription: PropTypes.string,
    pageKeywords   : PropTypes.string,
    isMobile       : PropTypes.bool,
  };

  componentDidMount() {
    setTimeout(() => {
      window && sendEvent(window, 'resize');
    });
  }

  render() {
    const { dispatch, title, inPopup, pageTitle, pageDescription, pageKeywords, children, isMobile, ...rest } = this.props;

    const content = (
      <article className={classNames(classes.article, { [classes.popupArticle]: inPopup })} {...rest}>
        {(title && !inPopup) ? (
          <h1 className={classes.header}>{title}</h1>
        ) : false}

        {(pageTitle || pageDescription || pageKeywords) ?
          (
            <Helmet
              title = {pageTitle}
              meta  = {[
                ...(pageDescription ? [{ name: 'description', content: pageDescription }] : []),
                ...(pageKeywords ? [{ name: 'keywords', content: pageKeywords }] : []),
              ]}
            />
          ) :
          null
        }

        <div className={classes.text}>
          {children}
        </div>
      </article>
    );

    if (inPopup) {
      return [
        <DialogTitle
          key="title"
          classes={{
            root: classNames(classes.dialogTitle, {
              [classes.dialogTitleMobile]: isMobile
            })
          }}
        >{title}</DialogTitle>,
        <DialogContent
          key="content"
        >{content}</DialogContent>
      ];
    } else return content;
  }
}
